<template>
	<pre v-html="$t('terms.agreement10')"></pre>
</template>

<script>
export default {
	name: 'Agreement10',
};
</script>

<style scoped></style>
